import { render, staticRenderFns } from "./layout-product-data.vue?vue&type=template&id=5872e100&scoped=true&"
import script from "./layout-product-data.vue?vue&type=script&lang=js&"
export * from "./layout-product-data.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-data.vue?vue&type=style&index=0&id=5872e100&lang=scss&scoped=true&"
import style1 from "./layout-product-data.vue?vue&type=style&index=1&lang=css&"
import style2 from "./layout-product-data.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872e100",
  null
  
)

export default component.exports